module.exports = __webpack_public_path__ + "static/media/market_research_summary.fa99b486.png";